import { Navbar, Nav, Button, Container,Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import API from "../services/api";
import skillsuprise from "../assets/skillsuprise.png";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const session = localStorage.getItem("session_id");
    setIsLoggedIn(!!session);
  }, []);

  // const handleLogout = async () => {
  //   try {
  //     const fd = new FormData();
  //     fd.append("session_id", localStorage.getItem("session_id"));
  //     await API.post("/auth/logout.php", fd);
  //   } catch (err) {
  //     // silent fail is fine
  //   }
  //   localStorage.removeItem("session_id");
  //   setIsLoggedIn(false);
  //   navigate("/");
  // };

  const confirmLogout = async () => {
    try {
      const fd = new FormData();
      fd.append("session_id", localStorage.getItem("session_id"));
      await API.post("/auth/logout.php", fd);
    } catch (err) {}
  
    localStorage.removeItem("session_id");
    setIsLoggedIn(false);
    setShowLogoutModal(false);
    navigate("/");
  };

  return (
    
    <Navbar
  expand="lg"
  className="py-3 shadow-sm"
  style={{
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e0e0e0",

    position: "sticky",   // ✅ key
    top: 0,               // ✅ stick to top
    zIndex: 1000          // ✅ stay above everything
  }}
>
      <Container fluid className="px-4 px-xl-5">
        {/* Left - Logo */}
        <Navbar.Brand as={Link} to="/" className="me-0 me-lg-5">
          <img
            src={skillsuprise}
            alt="Skills Uprise Logo"
            height="35"
            className="d-block"
            style={{ objectFit: "contain" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar">
          {/* Center - All navigation links */}
          <Nav className="mx-auto align-items-center gap-1 gap-lg-2">
            <Nav.Link
              as={Link}
              to="/"
              className="fw-medium text-dark px-3"
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/about"
              className="fw-medium text-dark px-3"
            >
              About
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/courses"  
              className="fw-medium text-dark px-3"
            >
              Courses
            </Nav.Link>

            {isLoggedIn && (
  <Nav.Link
    as={Link}
    to="/dashboard"
    className="fw-medium text-dark px-3"
  >
    Dashboard
  </Nav.Link>
)}

            <Nav.Link
              as={Link}
              to="/internships"  
              className="fw-medium text-dark px-3"
            >
              Internships
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/instructions"  // ← update path if different
              className="fw-medium text-dark px-3"
            >
              Instructions
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/gallery"
              className="fw-medium text-dark px-3"
            >
              Gallery
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/faq"  // ← better name than /instructions ?
              className="fw-medium text-dark px-3"
            >
              FAQ
            </Nav.Link>
          </Nav>

          {/* Right - Auth buttons */}
          <Nav className="align-items-center ms-lg-4 mt-3 mt-lg-0">
            {!isLoggedIn ? (
              <>
                <Button
                  as={Link}
                  to="/login"
                  variant="outline-primary"
                  className="px-4 me-3 fw-medium"
                  style={{
                    borderRadius: "50px",
                    minWidth: "110px",
                  }}
                >
                  Login
                </Button>

                <Button
                  as={Link}
                  to="/signup"
                  variant="primary"
                  className="px-4 fw-medium"
                  style={{
                    borderRadius: "50px",
                    minWidth: "130px",
                  }}
                >
                  Sign Up
                </Button>
              </>
            ) : (
              <Button
                variant="outline-danger"
                className="px-4 fw-medium"
                style={{ borderRadius: "50px" }}
                onClick={() => setShowLogoutModal(true)}
              >
                Logout
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
      <Modal
  show={showLogoutModal}
  onHide={() => setShowLogoutModal(false)}
  centered
>
  <Modal.Body className="text-center p-4">

    <h5 className="fw-bold mb-3">Are you sure?</h5>
    <p className="text-muted mb-4">
      Do you really want to logout from your account?
    </p>

    <div className="d-flex justify-content-center gap-3">

      <Button
        variant="outline-secondary"
        onClick={() => setShowLogoutModal(false)}
        className="px-4"
      >
        Cancel
      </Button>

      <Button
        variant="danger"
        onClick={confirmLogout}
        className="px-4"
      >
        Yes, Logout
      </Button>

    </div>

  </Modal.Body>
</Modal>
    </Navbar>
  );
};

export default Header;